import type { PermissionKey } from '@/lib/services/permissions.service';

/**
 * Who may open the Calendar page and connect Google or Outlook: anyone whose meetings, orders, inspections or
 * leads and deals can land in a calendar (CRM calendar integration, AC-44), not only Meetings users.
 */
export const CALENDAR_PAGE_PERMISSIONS: readonly PermissionKey[] = [
	'meetings.read.own',
	'meetings.read.all',
	'orders.read.own',
	'orders.read.all',
	'inspections.read',
	'leads.read.own',
	'leads.read.all',
	'deals.read.own',
	'deals.read.all',
];
